<template>
    <div ref="swiper" class="swiper" :class="mainClass">
        <slot name="swiper-banner"></slot>
        <div class="swiper-wrapper" :class="wrapperClass">
            <slot></slot>
        </div>
        <div class="swiper-pagination" :class="paginationClass"></div>
        <div class="swiper-scrollbar" v-if="hasScrollbar"></div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import { Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/swiper-bundle.min.css'

export default {
    props: {
        slidesPerView: {
            type: String,
            default: () => 'auto',
            required: false,
        },
        breakpoints: {
            type: Object | Array,
            default: () => [],
            required: false,
        },
        mainClass: {
            type: String,
            default: () => 'swiper',
            required: false
        },
        wrapperClass: {
            type: String,
            default: () => '',
            required: false,
        },
        hasScrollbar: {
            type: Boolean,
            default: () => false,
            required: false,
        },
        hasPagination: {
            type: Boolean,
            default: () => false,
            required: false,
        },
        paginationClass: {
            type: String,
            default: () => '',
            required: false
        },
        paginationType: {
            type: String,
            default: () => 'bullets',
            required: false
        },
        canLoop: {
            type: Boolean,
            default: () => false,
            required: false
        },
    },
    computed: {
        swiperBreakpoints() {
            const breakpointsFormatted = {};
            Object.keys(this.breakpoints).forEach(breakpoint => {
                breakpointsFormatted[breakpoint] = {
                    slidesPerView: this.breakpoints[breakpoint]
                };
            });
            return breakpointsFormatted;
        }
    },
    mounted() {
        const swiperOptions = {
            modules: [Pagination, Scrollbar],
            spaceBetween: '30px',
            loop: this.canLoop,
            grabCursor: true,
            slidesPerView: this.slidesPerView,
            breakpoints: this.swiperBreakpoints,
            keyboard: {
                enabled: true,
            },
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        };

        if (this.hasScrollbar) {
            swiperOptions.scrollbar = {
                el: ".swiper-scrollbar",
                hide: false,
            };
        }

        if (this.hasPagination) {
            swiperOptions.pagination = {
                el: '.swiper-pagination',
                type: this.paginationType,
                clickable: true,
            };
        }

        new Swiper(this.$refs.swiper, swiperOptions);
    },
}

</script>

<style scoped>
.swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
